import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
export function Modal({ isOpen, onClose, title, children, size = "md", className = "" }) {
    const modalRef = useRef(null);
    const previousFocusRef = useRef(null);
    useEffect(() => {
        if (isOpen) {
            previousFocusRef.current = document.activeElement;
            modalRef.current?.focus();
            document.body.style.overflow = "hidden";
        }
        else {
            document.body.style.overflow = "";
            previousFocusRef.current?.focus();
        }
        return () => {
            document.body.style.overflow = "";
        };
    }, [isOpen]);
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === "Escape" && isOpen) {
                onClose();
            }
        };
        document.addEventListener("keydown", handleEscape);
        return () => document.removeEventListener("keydown", handleEscape);
    }, [isOpen, onClose]);
    if (!isOpen)
        return null;
    const sizeClasses = {
        sm: "max-w-sm",
        md: "max-w-md",
        lg: "max-w-lg",
        xl: "max-w-xl",
    };
    return (_jsxs("div", { className: "fixed inset-0 z-50 flex items-center justify-center p-4", role: "dialog", "aria-modal": "true", "aria-labelledby": title ? "modal-title" : undefined, children: [_jsx("div", { className: "absolute inset-0 bg-black bg-opacity-50", onClick: onClose, "aria-hidden": "true" }), _jsxs("div", { ref: modalRef, tabIndex: -1, className: `relative w-full ${sizeClasses[size]} rounded-lg bg-white shadow-lg ${className}`, children: [title && (_jsxs("div", { className: "flex items-center justify-between border-b border-gray-200 p-4", children: [_jsx("h2", { id: "modal-title", className: "text-lg font-semibold text-black", children: title }), _jsx("button", { onClick: onClose, className: "rounded p-1 text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-300", "aria-label": "Close modal", children: _jsx("svg", { className: "h-5 w-5", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: _jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M6 18L18 6M6 6l12 12" }) }) })] })), _jsx("div", { className: "p-4", children: children })] })] }));
}
